



































































































































import BaseComponent from '@/components/BaseComponent';
import { NSPTableSettings } from '@/components/Table/typing/table-settings';
import { miscTypes } from '@/store/modules/misc/miscTypes';
import MaterialIcon from '@/typing/enums/materialIcon.enum';
import Component from 'vue-class-component';
import NSPTable from '@/components/Table/NSPTable.vue';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import DateInput from '@/components/DateInput/DateInput.vue';
import Button from '@/components/Button/Button.vue';
import Modal from '@/components/Modal/Modal.vue';
import { INSPTableEvent } from '@/components/Table/typing/table-event.interface';
import { PostPutProject } from '@/typing/api/postProject.class';
import { isUndefined } from '@/utils/isUndefined';
import { ValidationResult } from '@/typing/validationResult.class';
import { closeProject, postProject, putProject } from '@/api/data';
import showNotification from '@/utils/notification';
import { Project } from '@/typing/api/project.class';
import { Contractor } from '@/typing/api/contractor.class';
import { projectTypes } from '@/store/modules/project/projectTypes';

@Component({
  components: {
    NSPTable,
    Button,
    Modal,
    Dropdown,
    DateInput,
  },
})
export default class ProjectOverview extends BaseComponent {
  tSettings = new NSPTableSettings();
  showAddProjectModal = false;
  newProject = new PostPutProject();
  projectValidationResult: ValidationResult = new ValidationResult();
  submittedProjectOnce = false;
  toCloseProject: Project | null = null;
  projectFilterTerm = '';

  get contractorItems(): any[] {
    const contractors = this.$state.project.projectData?.contractors;
    if (!contractors) return [];
    return contractors.map((c: Contractor) => {
      return { label: c.name, value: c.id };
    });
  }
  get shownProjects(): Project[] {
    const projects = [...this.$state.project.projectData?.projects ?? []];

    if (this.projectFilterTerm.trim().length > 0) {
      return projects.filter((p: Project) =>
        JSON.stringify(p)
          .toLowerCase()
          .includes(this.projectFilterTerm.toLowerCase())
      );
    }

    return projects;
  }

  mounted(): void {
    this._genericInit(true);
    this._setPageName('Projecten');

    if (this.isClient()) {
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Projecten',
        active: true,
        navPath: '/projects',
      });
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Rapporten',
        active: false,
        navPath: '/reports',
      });
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Exporteren',
        active: false,
        navPath: '/export',
      });
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Beheer',
        active: false,
        navPath: '/manage',
      });
    }

    this.tSettings
      .addColumn({
        label: 'Project',
        valueKey: 'name',
      })
      .addColumn({
        label: 'Projectnummer',
        valueKey: 'number',
      })
      .addColumn({
        label: 'Omschrijving',
        valueKey: 'description',
      });

    if (this.isClient()) {
      this.tSettings.addColumn({
        label: 'Aannemer',
        valueKey: 'contractorId',
        formatFn: (val: any) => {
          return this.$state.project.projectData?.getContractorById(val)?.name ?? val;
        },
      });

      this.tSettings.addAction({
        iconName: MaterialIcon.Edit,
        isAvailable: () => true,
        id: 'edit',
      });

      this.tSettings.addAction({
        name: 'Afsluiten',
        isAvailable: () => true,
        id: 'close-confirm',
      });
    }
  }

  handleTableEvent(e: INSPTableEvent): void {
    if (e.actionID === 'edit') {
      this.newProject = new PostPutProject(e.item);
      this.showAddProjectModal = true;
    } else if (e.actionID === 'close-confirm') {
      this.toCloseProject = e.item;
    }
  }

  validateProject(): void {
    this.projectValidationResult = this.newProject.validate(
      isUndefined(this.newProject.id) ? 'POST' : 'PUT'
    );
  }

  onReportAddModalClose(): void {
    this.newProject = new PostPutProject();
    this.showAddProjectModal = false;
    this.submittedProjectOnce = false;
  }

  onRejectCloseProject(): void {
    (this.$refs.closeProjectModal as Modal).closeModal();
  }

  async onConfirmCloseProject(): Promise<any> {
    if (this.toCloseProject && !isUndefined(this.toCloseProject.id)) {
      try {
        await closeProject(this.toCloseProject.id ?? -1);
        await this.$store.dispatch(projectTypes.actions.FETCH_PROJECT_DATA);
        showNotification(`Project succesvol afgesloten.`);
        (this.$refs.closeProjectModal as Modal).closeModal();
      } catch (error: any) {
        showNotification(
          `Er is een probleem opgetreden bij het afsluiten van het project.`
        );
      }
    }
  }

  async submitProject(): Promise<any> {
    let apiCall;

    this.validateProject();
    if (!this.projectValidationResult.isValid) return;

    if (isUndefined(this.newProject.id)) {
      apiCall = postProject(this.newProject);
    } else {
      apiCall = putProject(this.newProject);
    }

    try {
      await apiCall;
      showNotification('Project successfully saved.');
      (this.$refs.projectModal as Modal).closeModal();
      await this.$store.dispatch(projectTypes.actions.FETCH_PROJECT_DATA);
    } catch (error: any) {
      showNotification(
        `Er is een probleem opgetreden bij het opslaan van het project.`
      );
    }
  }
}
